<h1 mat-dialog-title>Attachment upload error</h1>
<div mat-dialog-content>
    <p>An error occurred while uploading your claim documents.</p>
    <br />
    <p>Files that could not be uploaded:</p>
    <br />
    <p *ngFor="let fileName of data.fileNames">{{ fileName }}</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>OK</button>
</div>